import {PrefixedProjectUid} from "@buildwithflux/identifiers-schema";
import {Schema} from "effect";

import {PermissionSchema} from "./permissionType";

/**
 * HTTP wire shapes for the viewer-access endpoint: "which permission does the
 * caller hold on each of these documents now?". The server runs the
 * viewer-access programs in `@buildwithflux/permissions-logic/access` for the
 * authenticated caller and returns one resolved permission level per
 * document. Document identifiers travel in the canonical prefixed `prj_…`
 * form.
 */

/** Upper bound on the documents one request can resolve. */
export const VIEWER_ACCESS_MAX_DOCUMENTS = 200;

export class ResolveViewerAccessRequest extends Schema.Class<ResolveViewerAccessRequest>("ResolveViewerAccessRequest")({
    documentUids: Schema.Array(PrefixedProjectUid.schema).pipe(Schema.maxItems(VIEWER_ACCESS_MAX_DOCUMENTS)),
}) {}

export class ViewerAccessDocumentResult extends Schema.Class<ViewerAccessDocumentResult>("ViewerAccessDocumentResult")({
    documentUid: PrefixedProjectUid.schema,
    /** `"none"` for a missing document and for a document the caller cannot open. */
    permission: PermissionSchema,
    /**
     * True when Flux Support holds an active role on the document now. Present
     * only for a caller with the `internal` claim; omitted for other callers.
     */
    sharedWithSupport: Schema.optional(Schema.Boolean),
}) {}

export class ResolveViewerAccessResponse extends Schema.Class<ResolveViewerAccessResponse>(
    "ResolveViewerAccessResponse",
)({
    /** One entry per distinct requested document, in first-seen request order. */
    documents: Schema.Array(ViewerAccessDocumentResult),
}) {}
